import React, { useContext, useEffect } from "react";
import "./signUp.css";
import { useHistory } from "react-router-dom";
import Footer from "../../component/Footer";
import { dataContext } from "../../context";
import SignUpForm from "../../component/SignUpForm";

function SignUp() {
  let history = useHistory();
  const { currentUser } = useContext(dataContext);
  useEffect(() => {
    if (currentUser) {
      history.push("/");
    }
  }, []);
  return (
    <section
      className="u-clearfix u-image u-section-1"
      id="sec-c4fa"
      data-image-width="1920"
      data-image-height="1200"
    >
      <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <div className="u-expanded-width-xs u-form u-grey-15 u-form-1 sign-up-area">
          <SignUpForm />
          <div className="full-w d-flex justify-center login-redirect-area">
            <a
              onClick={() => {
                history.push("/login");
              }}
            >
              Zaten üye misiniz?
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/page/signUp/index.js